import React, { memo } from 'react';

import { AdfoxContextProviderProps } from '../../../../../../utils/AdfoxContext';
import { AdFoxBannerContainer } from 'shared/containers/AdFoxBannerContainer';
import { stopPropagation } from 'shared/utils/events/stopPropagation';

const POST_VIEW_ANALYTICS_DATA: AdfoxContextProviderProps['postViewAnalyticsData'] = {
  place: 'card',
  place__DEPRECATED: 'offersSerp',
  name__DEPRECATED: 'Listing_native_TGB',
};
const SIZE: AdfoxContextProviderProps['size'] = { width: '100%', height: 20 };
const P_PARAMS: AdfoxContextProviderProps['pParams'] = { p1: 'ctbng', p2: 'gbvb' };

type TMortgageCardCreatorBannerProps = {
  position: number;
};

export const MortgageCardCreatorBanner = memo<TMortgageCardCreatorBannerProps>(function MortgageCardCreatorBanner({
  position,
}) {
  return (
    <AdFoxBannerContainer
      position={position}
      onClick={stopPropagation}
      bannerName="AdFox баннер ипотеки под ценой"
      size={SIZE}
      pParams={P_PARAMS}
      postViewAnalyticsData={POST_VIEW_ANALYTICS_DATA}
    />
  );
});
